import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { SelectFiltersPopUpComponent } from "src/app/user/report-configuration/select-filters-pop-up/select-filters-pop-up.component";
import { EtlService } from "src/app/user/vault-data-migration-etl/etl.service";
import { LocalStorageSettingsService } from "./local-storage-settings.service";
import { ReportlinksserviceService } from "src/app/user/reportlinks/reportlinksservice.service";
import { FormFieldsTrimer } from "../Validations/FormFieldsTrimer";
import { constants } from "src/app/shared/common/contants";
import * as moment from "moment";
import { Router } from "@angular/router";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AnalysisService {
jsuitepropertyValue: any;
  filterListBody = [];
  datasetQuickSight = {
    s3Path: "",
    dataSetId: "",
    dataSetName: "",
    dnsId: "",
    filterList: [],
    visualType: "",
    visualId: 0,
  };

  constructor(
    private dialog: MatDialog,
    private etlService: EtlService,
    private spinner: NgxUiLoaderService,
    private snackbar: MatSnackBar,
    private localStorageSettings: LocalStorageSettingsService,
    private formFieldsTrimer: FormFieldsTrimer,
    private linkservice: ReportlinksserviceService,
    private constants: constants,
    private router: Router
  ) {}


  // This Is Common Used To Generate Quick Sight For Selected Dataset
  // @params data ---- (Pass In the Row data --> i.e data.rowData.xyz)
  analysis(data) {
    console.log(data);
    return new Observable((observer) => {
    let dialogRef = this.dialog.open(SelectFiltersPopUpComponent, {
      width: "90%",
      autoFocus: false,
      maxWidth: "100vw",
      height: "96%",
      disableClose: true,
      data: {
        dataSetId: data.rowData.reportcreationid,
        objectGroup: data.rowData.objectGroup,
        columnsData: data.rowData.columns,
        datasetData: data.rowData,
        showVisualDropDowns: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);

       // CASE 1: User pressed cancel
      if (!result || !result.selectedFiltersListString) {
        observer.next("cancel");
        observer.complete();
        return;
      }

      let getdata = result.selectedFiltersListString;
      if (getdata) {
        let filterList = JSON.parse(getdata);
        console.log(filterList);
        let dnsId = localStorage.getItem("dnsName");
        this.etlService
          .retrieveJsuiteProperty(dnsId, "UIDateFormat")
          .subscribe((res) => {
            this.spinner.start();
            console.log("Test string");
            console.log(res);
            if (res) {
              this.jsuitepropertyValue = res.propertyvalue;
              console.log(this.jsuitepropertyValue);
              this.filterListBody = [];
              for (let i = 0; i < filterList.length; i++) {
                if (
                  filterList[i].whereCondition !==
                    "CalculatedFieldForReports" &&
                  filterList[i].whereCondition !== "count"
                ) {
                  console.log(filterList[i].whereValue.length);
                  let filterValue;
                  let showInQuicksightVisuals: any = "";
                  if (filterList[i].showInQuicksightVisuals) {
                    showInQuicksightVisuals =
                      filterList[i].showInQuicksightVisuals;
                  } else {
                    showInQuicksightVisuals = false;
                  }
                  let displayCalculatedFieldsIn = "columns";
                  if (filterList[i].displayCalculatedFieldsIn) {
                    displayCalculatedFieldsIn =
                      filterList[i].displayCalculatedFieldsIn;
                  } else {
                    displayCalculatedFieldsIn = "columns";
                  }
                  if (filterList[i].whereCondition == "IN") {
                    // filterValue = this.convertArrayToString(filterList[i].whereValue)
                    filterValue = JSON.stringify(filterList[i].whereValue);
                  } else if (filterList[i].whereCondition == "BETWEEN") {
                    if (
                      filterList[i].type == "DateTime" ||
                      filterList[i].type == "Date"
                    ) {
                      if (filterList[i].whereValue.length > 0) {
                        const parsedDate = moment(
                          filterList[i].whereValue,
                          "YYYY-MM-DD"
                        ).startOf("day");
                        filterList[i].whereValue = parsedDate.format(
                          this.jsuitepropertyValue
                        );
                      } else {
                        filterList[i].whereValue = "";
                      }

                      if (filterList[i].whereValue1.length > 0) {
                        const parsedDate2 = moment(
                          filterList[i].whereValue1,
                          "YYYY-MM-DD"
                        ).startOf("day");
                        filterList[i].whereValue1 = parsedDate2.format(
                          this.jsuitepropertyValue
                        );
                      }
                    }
                    filterValue = [
                      this.removeSingleQuotes(filterList[i].whereValue),
                      this.removeSingleQuotes(filterList[i].whereValue1),
                    ];
                    filterValue = JSON.stringify(filterValue);
                  } else {
                    filterValue = this.removeSingleQuotes(
                      filterList[i].whereValue
                    );
                    if (
                      filterList[i].type == "DateTime" ||
                      filterList[i].type == "Date"
                    ) {
                      if (filterList[i].whereValue.length > 0) {
                        const parsedDate = moment(
                          filterList[i].whereValue,
                          "YYYY-MM-DD"
                        ).startOf("day");
                        filterValue = parsedDate.format(
                          this.jsuitepropertyValue
                        );
                      } else {
                        filterValue = "";
                      }
                    }
                  }
                  console.log(filterList[i].whereValue.length);
                  console.log(filterValue);
                  console.log(filterList[i].excludeNull);

                  if (filterList[i].excludeNull == undefined) {
                    let priority = "";
                    if (filterList[i].priority) {
                      priority = filterList[i].priority;
                    } else {
                      priority = "";
                    }
                    let listObject = {
                      label: filterList[i].label,
                      columnName: filterList[i].whereKeyAlias,
                      matchOperator: filterList[i].whereCondition,
                      filterValue: filterValue,
                      filterType: "String",
                      excludeNull: false,
                      showOnlyNulls: false,
                      showInQuicksightVisuals: showInQuicksightVisuals,
                      displayCalculatedFieldsIn: displayCalculatedFieldsIn,
                      priority: priority,
                    };
                    if (
                      filterList[i].type == "DateTime" ||
                      filterList[i].type == "Date"
                    ) {
                      listObject.filterType = filterList[i].type;
                    }
                    this.filterListBody.push(listObject);
                  } else if (
                    (filterList[i].whereValue.length > 0 &&
                      filterValue != "undefined") ||
                    filterList[i].excludeNull ||
                    filterList[i].showOnlyNulls
                  ) {
                    let priority = "";
                    if (filterList[i].priority) {
                      priority = filterList[i].priority;
                    } else {
                      priority = "";
                    }
                    let listObject = {
                      label: filterList[i].label,
                      columnName: filterList[i].whereKeyAlias,
                      matchOperator: filterList[i].whereCondition,
                      filterValue: filterValue,
                      filterType: "String",
                      excludeNull: filterList[i].excludeNull,
                      showOnlyNulls: filterList[i].showOnlyNulls,
                      showInQuicksightVisuals: showInQuicksightVisuals,
                      displayCalculatedFieldsIn: displayCalculatedFieldsIn,
                      priority: priority,
                    };
                    if (
                      filterList[i].type == "DateTime" ||
                      filterList[i].type == "Date"
                    ) {
                      listObject.filterType = filterList[i].type;
                    }
                    this.filterListBody.push(listObject);
                  }
                }
              }

              for (let i = 0; i < this.filterListBody.length; i++) {
                const followUp = this.filterListBody[i];

                if (
                  followUp.label?.toLowerCase() === "followup date" &&
                  followUp.matchOperator === "BETWEEN" &&
                  (followUp.filterType === "DateTime" ||
                    followUp.filterType === "Date") &&
                  followUp.filterValue?.length > 0
                ) {
                  let datesArray: any[] = [];

                  try {
                    datesArray = JSON.parse(followUp.filterValue);
                  } catch (err) {
                    console.error(
                      "Invalid JSON in filterValue:",
                      followUp.filterValue
                    );
                    continue; // skip this loop if JSON parsing fails
                  }

                  const startDateValue = moment(datesArray[0]).format(
                    "YYYY-MM-DD"
                  );
                  const endDateValue = moment(datesArray[1]).format(
                    "YYYY-MM-DD"
                  );

                  for (let j = this.filterListBody.length - 1; j >= 0; j--) {
                    const calculated = this.filterListBody[j];

                    if (
                      calculated.matchOperator ===
                        "CalculatedFieldWithFilter" &&
                      calculated.label === "Max_Case_Version"
                    ) {
                      if (calculated.priority === "postMax") {
                        let calculatedFieldValue = calculated.filterValue;

                        if (calculatedFieldValue) {
                          calculatedFieldValue = calculatedFieldValue
                            .replaceAll("${startDate}", `"${startDateValue}"`)
                            .replaceAll("${endDate}", `"${endDateValue}"`);

                          this.filterListBody[j].filterValue =
                            calculatedFieldValue;
                          console.log("Updated:", calculatedFieldValue);
                        }
                      } else if (calculated.priority === "preMax") {
                        this.filterListBody.splice(j, 1);
                      }
                    }
                  }
                  break;
                }
              }

              // If no followup date found, remove Max_Case_Version postMax block
              const hasFollowup = this.filterListBody.some(
                (f) =>
                  f.label?.toLowerCase() === "followup date" &&
                  f.matchOperator === "BETWEEN" &&
                  (f.filterType === "DateTime" || f.filterType === "Date")
              );

              if (!hasFollowup) {
                const index = this.filterListBody.findIndex(
                  (f) =>
                    f.matchOperator === "CalculatedFieldWithFilter" &&
                    f.priority === "postMax" &&
                    f.label === "Max_Case_Version"
                );
                if (index !== -1) {
                  this.filterListBody.splice(index, 1);
                }
              }

              this.datasetQuickSight.filterList = this.filterListBody;
              console.log(this.datasetQuickSight);
              // this.spinner.stop();

              if (data.rowData.status === "No") {
                this.snackbar.open(this.constants.Deleted_Dataset, "OK", {
                  duration: 5000,
                });
                return;
              }
              this.datasetQuickSight.dataSetId = data.rowData.reportcreationid;
              this.datasetQuickSight.dataSetName = data.rowData.datasetname;
              this.datasetQuickSight.dnsId =
                this.localStorageSettings.getSettings("dnsName");
              this.datasetQuickSight.s3Path = data.rowData.dataSets3Path;
              if (result.visualType) {
                this.datasetQuickSight.visualType = result.visualType;
              } else {
                this.datasetQuickSight.visualType = "Tabular";
              }

              if (result.visualId > 0) {
                this.datasetQuickSight.visualId = result.visualId;
              } else {
                this.datasetQuickSight.visualId = 0;
              }
              console.log(this.datasetQuickSight);

              this.linkservice
                .generateDatasetAnalysis(this.datasetQuickSight)
                .subscribe((result) => {
                  this.snackbar.open(result.data, "OK", {
                    duration: 5000,
                  });
                  this.spinner.stop();
                  if (result.data === "Analysis Generated") {
                    // SUCCESS
                    observer.next("success");
                    observer.complete();

                    const analysisReference = data.rowData.analysisreference;
                    const url = this.router.serializeUrl(
                      this.router.createUrlTree(["/user/Menubar/quickSight"], {
                        queryParams: { analysis: analysisReference },
                      })
                    );
                    window.open(url, "_blank");
                    // this.router.navigateByUrl('/user/Menubar', { skipLocationChange: true }).then(() =>
                    //   this.router.navigate(["/user/Menubar/quickSight"], { queryParams: { analysis: data.rowData } }));
                  }
                  else{
                      // CASE 2: API FAILED
                      observer.next("failed");
                      observer.complete();
                  }
                });
            }
          });
      } else {
            // CASE : no getdata
            observer.next("failed");
            observer.complete();
        this.filterListBody = [];
      }
    });
      });
  }

  removeSingleQuotes(str) {
    console.log(str);

    return str.replace(/['%]/g, "");
  }
}
